import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
let Clear = class Clear extends Vue {
    clearStorage() {
        localStorage.clear();
        this.$store.dispatch('ToastMessage', { type: 'error', message: 'The local storage has been cleared' });
    }
};
Clear = __decorate([
    Component({
        data() {
            return {
                status: '',
            };
        },
        created() {
            this.clearStorage();
        },
    })
], Clear);
export default Clear;
